/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

namespace DealerwareWebServices {
    "use strict";

    export interface ILocationFactory {
        getInstance() : Location;
    }

    export interface ICurrentLocation {
        get() : ng.IPromise<any>;
    }

    export interface ILocationSettings {
        id                              : number;
        view_vehicle_under_contract     : boolean;
        customers_charged               : boolean;
        contract_required               : boolean;
        dms_provider                    : string;
        dms_account_name                : string;
        metric                          : boolean;
        minimum_age                     : number;
        program_car_utilization         : boolean;
        custom_minimum_age              : boolean;
    }

    export interface ILocation {
        id                              : number;
        address_id                      : number;
        primary_name                    : string;
        secondary_name                  : string;
        phone_number                    : string;
        email                           : string;
        image_url                       : string;
        line1                           : string;
        line2                           : string;
        city                            : string;
        state                           : string;
        zip                             : string;
        latitude                        : string;
        longitude                       : string;
        showMap                         : boolean;

        settings                        : ILocationSettings;

        agreedToTerms                   : boolean;

        // @TODO
        //address: IDealerwareAddress;

        create (data: any)              : any;
        load   (id?: number)            : any;
        add    ()                       : ng.IPromise<any>;
        save   (id?: number)            : ng.IPromise<any>;
        update (id?: number)            : ng.IPromise<any>;
        loadSettings (id?: number)      : ng.IPromise<any>;
        saveSettings ()                 : ng.IPromise<any>;
        fill   (data: any)              : any;
        clear  ()                       : void;

        isLocationUnchanged ()              : boolean;
        isLocationExistingOrUnchanged ()    : boolean;
        areSettingsUnchanged ()             : boolean;
        areSettingsExistingOrUnchanged ()   : boolean;
        isAllDataExistingOrUnchanged ()     : boolean;

        //clearAddress()                      : void;
        //loadAddress(locationId?: number)    : ng.IPromise<{}>;
    }
}
